/**
 * One owner's chip on figure S5's entity header. A name renders only for an
 * owner this portfolio actually holds a row for; ★ means they are in the
 * portfolio by invitation — which says how they came to be here, never what
 * they show you.
 */
export interface EntityBadgeProps {
  entityName: string
  /** In this portfolio by invitation, rather than by granting it directly. */
  byInvitation?: boolean
  title?: string
}

export default function EntityBadge({ entityName, byInvitation = false, title }: EntityBadgeProps) {
  return (
    <span
      data-testid="entity-badge"
      title={title}
      className="inline-flex items-center rounded-full bg-iflow-100 px-2.5 py-0.5 text-[12px] font-semibold text-iflow-700"
    >
      {entityName}
      {byInvitation && <span className="ml-1">★</span>}
    </span>
  )
}
